<template>
    <div class="the-detail-header">
        <isc-breadcrumb separator=">">
            <isc-breadcrumb-item :to="{ path: '/' }">文档中心</isc-breadcrumb-item>
            <template v-for="item in contentPath">
                <isc-breadcrumb-item :key="item.id">{{ item.title }}</isc-breadcrumb-item>
                <!-- <isc-breadcrumb-item v-else :key="item.id" :to="{ query: { bookId: item.id } }">{{
                    item.title
                }}</isc-breadcrumb-item> -->
            </template>
        </isc-breadcrumb>
    </div>
</template>

<script>
import { getContentPath, queryCategoryByDocId } from '../../service';

export default {
    name: 'ThePathHeader',

    data() {
        return {
            contentPath: []
        };
    },

    computed: {
        pageId() {
            return this.$route.query.pageId;
        }
    },

    watch: {
        pageId: {
            immediate: true,
            handler(val) {
                if (!val) return;

                this.getData(val);
            }
        }
    },

    async created() {
        let currentProduct = sessionStorage.getItem("currentProduct");
        if (!currentProduct) {
            const {title} = await queryCategoryByDocId(this.$route.query.bookId)
            const bookInfo = title.split(" ");
            currentProduct = title.replace(` ${bookInfo[bookInfo.length -1]}`, "");
        }
        this.contentPath = [
            {title: currentProduct, id: 0},
            {title: '成长地图', id: 1}
        ]
    },

    methods: {
        async getData(val) {
            this.contentPath = await getContentPath(val);

            // 页签修改 {文档名称}-{页面名称}
            if (this.contentPath.length > 1) {
                document.title = this.contentPath[0].title + '-' + this.contentPath[this.contentPath.length - 1].title;
            } else {
                document.title = this.contentPath[0].title;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../../node_modules/@isyscore/styles/variables';

.the-detail-header {
    padding-top: 40px;
    padding-bottom: 10px;
    margin-bottom: 30px;
    border-bottom: 1px solid #f2f2f2;

    ::v-deep {
        .isc-breadcrumb__inner.is-link {
            color: $app-primary-color;
        }
    }
}
</style>
